module.exports = __webpack_public_path__ + "assets/img/return-05ce4c71.png";